import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { FormFields } from '../../../components/UpsertInsuranceModal/UpsertInsuranceModal.meta';
import { Select } from '../../../../../CommonComponents/OPL/Select/Select/Select';
import { InsuranceData } from '../../../useInsurance';

interface Props {
  data: InsuranceData;
}

export const ManagementStyles = ({ data }: Props) => {
  const formBag = useFormContext<FormFields>();

  const {
    accountOptions: {
      ManagementStyles: managementStylesOptions,
      AssetBucketingByManagementStyle: assetBucketingByManagementStyleOptions,
    },
  } = data;

  const isOrion = formBag.watch('IsOrion');

  if (!assetBucketingByManagementStyleOptions && !isOrion) {
    return null;
  }

  const options = managementStylesOptions.map(option => ({
    label: option.name,
    value: option.id,
    defaultBucket: option.defaultBucket,
  }));

  return (
    <Controller
      control={formBag.control}
      name="OrionManagementStyleId"
      render={({ field: { value, onChange, disabled } }) => {
        return (
          <Select
            isPortal
            value={options.find(option => option.value === value) ?? null}
            options={options}
            onChange={option => {
              onChange(option?.value ?? null);

              if (option) {
                formBag.setValue(
                  'CustomAssetBucketIndex',
                  option.defaultBucket === null ? -1 : option.defaultBucket,
                );
              }
            }}
            label="Management Style"
            disabled={disabled || (assetBucketingByManagementStyleOptions && isOrion)}
          />
        );
      }}
    />
  );
};
